import { GeneratedTableColumn } from "./GeneratedTableColumn";
import { Table } from "./Table";
import { TableColumnProps } from "./TableColumnProps";
import { ToolsHeadingTableCell } from "./ToolsHeadingTableCell";

export class ToolsTableColumn extends GeneratedTableColumn {
    constructor(props?: Partial<TableColumnProps>) {
        super(props);
        this.headingDef = this.createHeadingCell();
        this.cellDef = this.createCellDef(this.table);
    }

    private createHeadingCell(): ToolsHeadingTableCell {
        const result = new ToolsHeadingTableCell({ table: this.table });
        return result;
    }

    private createCellDef(table: Table): any {
        return {
            def: {
                cellProps: { table },
                type: "toolscell"
             }
        };
    }
}
